<ngx-spinner bdColor="rgba(51,51,51,0.55)" size="medium" color="#fff" type="line-spin-clockwise-fade" [fullScreen]="false">
    <p class="loading">{{ 'general.loading' | translate }}...</p>
</ngx-spinner>
<div class="col-12">
    <h2 class="page-title" tabindex="0">{{'breadcrumb.view-alert' | translate}}</h2>
    <xng-breadcrumb separator=" > ">
        <ng-container *xngBreadcrumbItem="let breadcrumb">
            <span *ngIf="breadcrumb">{{ 'breadcrumb.' + breadcrumb | translate }}</span>
        </ng-container>
    </xng-breadcrumb>
    <div *ngIf="selectedAlert">
        <div class="row">
            <div class="col-xs-12 col-lg-6">
                <div class="card border-top scroll">
                    <div class="col-12 mb-3">
                        <div class="row">
                            <div class="col-6">
                                <h5 class="mt-3 mb-0">{{'general.alert' | translate}} #{{selectedAlert.id}}</h5>
                            </div>
                            <div class="col-6 text-right mt-3">
                                <strong><span *ngIf="selectedAlert['inGeofence']==0" class="btn-orange p-1">{{'alert.out-of-zone' | translate}}</span></strong>
                                <strong><span *ngIf="selectedAlert['late']==='True'" class="btn-red p-1 ml-3">{{'alert.late_tag' | translate}}</span></strong>
                            </div>
                        </div>
                        <hr>
                        <div class="text-center"><img class="user-picture" [src]="profile['userPhoto'] ? profile['userPhoto'] : 'assets/images/default-user.jpeg'" alt="{{selectedAlert['createdByName']}}" width="100" height="100"><br></div>

                        <div class="row">
                            <div class="col-6 pr-0">
                                <strong>{{'alert.alert_type' | translate}}: </strong>
                            </div>
                            <div class="col-6 pl-0">
                                {{ selectedAlert.alertTypeName }}
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-6 pr-0">
                                <strong>{{'alert.triggered_by' | translate}}: </strong>
                            </div>
                            <div class="col-6 pl-0">
                                {{selectedAlert.createdByName}}
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-6 pr-0">
                                <strong>{{'alert.triggered_on' | translate}}: </strong>
                            </div>
                            <div class="col-6 pl-0">
                                {{ functionsService.convertUTCDateToLocalDate(selectedAlert.createdDate) }}
                            </div>
                        </div>
                        <div *ngIf="selectedAlert['attendedDate']" class="row">
                            <div class="col-6 pr-0">
                                <strong>{{'alert.attended_by' | translate}}: </strong>
                            </div>
                            <div class="col-6 pl-0">
                                {{selectedAlert.attendedByName}}
                            </div>
                        </div>
                        <div *ngIf="selectedAlert['attendedDate']" class="row">
                            <div class="col-6 pr-0">
                                <strong>{{'alert.attended_on' | translate}}: </strong>
                            </div>
                            <div class="col-6 pl-0">
                                {{ functionsService.convertUTCDateToLocalDate(selectedAlert.attendedDate) }}
                            </div>
                        </div>
                        <div *ngIf="selectedAlert['canceledDate']" class="row">
                            <div class="col-6 pr-0">
                                <strong>{{'alert.canceled_on' | translate}}: </strong>
                            </div>
                            <div class="col-6 pl-0">
                                {{ functionsService.convertUTCDateToLocalDate(selectedAlert.canceledDate) }}
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-6 pr-0">
                                <strong>{{'alert.closed_as' | translate}}: </strong>
                            </div>
                            <div class="col-6 pl-0">
                                <span *ngIf="selectedAlert.falseAlert === 1">{{'alert.false_alert' | translate}}</span>
                                <span *ngIf="selectedAlert.offZone">{{'alert.out_of_zone' | translate}}</span>
                                <span *ngIf="!selectedAlert.falseAlert&&!selectedAlert.offZone">{{'alert.attended' | translate}}</span>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-6 pr-0">
                                <strong>{{'alert.closed_by' | translate}}: </strong>
                            </div>
                            <div class="col-6 pl-0">
                                <span>{{selectedAlert.closedByName}}</span>
                            </div>
                        </div>
                        <div *ngIf="selectedAlert['closedDate']" class="row">
                            <div class="col-6 pr-0">
                                <strong>{{'alert.closed_on' | translate}}: </strong>
                            </div>
                            <div class="col-6 pl-0">
                                {{ functionsService.convertUTCDateToLocalDate(selectedAlert.closedDate) }}
                            </div>
                        </div>
                        <div *ngIf="geoAssignment" class="row">
                            <div class="col-6 pr-0">
                                <strong>{{'user.assigned_zone' | translate}}: </strong>
                            </div>
                            <div class="col-6 pl-0">
                                {{ selectedAlert.closingZone }}
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-6 pr-0">
                                <strong>{{'alert.total_time' | translate}}: </strong>
                            </div>
                            <div class="col-6 pl-0">
                                <span><span *ngIf="days&&days>0">{{days}} {{'general.days'| translate}}</span> {{alertTotalTime}}</span>
                            </div>
                        </div>
                        <div class="row" *ngIf="selectedAlert.timerStatus != 1">
                            <div class="col-6 pr-0">
                                <strong>{{'alert.unattended_total' | translate}}: </strong>
                            </div>
                            <div class="col-6 pl-0">
                                <span><span *ngIf="attendTotal&&attendTotal[0]>0">{{attendTotal[0]}} {{'general.days'| translate}}</span> {{selectedAlert.attendTotal}}</span>
                            </div>
                        </div>
                        <div class="row" *ngIf="selectedAlert.timerStatus != 1">
                            <div class="col-6 pr-0">
                                <strong>{{'alert.attended_total' | translate}}: </strong>
                            </div>
                            <div class="col-6 pl-0">
                                <span><span *ngIf="closeTotal&&closeTotal[0]>0">{{closeTotal[0]}} {{'general.days'| translate}}</span> {{selectedAlert.closeTotal}}</span>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-6 pr-0">
                                <strong>{{'general.time_attend' | translate}}: </strong>
                            </div>
                            <div class="col-6 pl-0">
                                {{selectedAlert.attendTime}}
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-6 pr-0">
                                <strong>{{'general.time_close' | translate}}: </strong>
                            </div>
                            <div class="col-6 pl-0">
                                {{selectedAlert.closeTime}}
                            </div>
                        </div>
                        <div *ngIf="selectedAlert['userGroups']" class="row">
                            <div class="col-6 pr-0">
                                <strong>{{'alert.user_groups' | translate}}</strong>
                            </div>
                            <div class="col-6 pl-0">
                                {{ selectedAlert.userGroups }}
                            </div>
                        </div>
                        <hr>
                        <span class="dark-gray-text uppercase"><strong>{{'general.user_information' | translate}}</strong></span>
                        <div class="row">
                            <div class="col-6 pr-0">
                                <strong>{{'general.name' | translate}}: </strong>
                            </div>
                            <div class="col-6 pl-0">
                                {{selectedAlert["createdByName"]}}
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-6 pr-0">
                                <strong>{{'general.phone_number' | translate}}: </strong>
                            </div>
                            <div class="col-6 pl-0">
                                {{profile["phoneNumber"]}}
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-6 pr-0">
                                <strong>{{'user.res_phone_number' | translate}}: </strong>
                            </div>
                            <div class="col-6 pl-0">
                                {{profile["phoneNumberResidence"]}}
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-6 pr-0">
                                <strong>{{'user.dob' | translate}}: </strong>
                            </div>
                            <div class="col-6 pl-0">
                                {{profile["dob"]?functionsService.convertUTCDateToLocalDateOnly(profile["dob"]+'T12:00:00'):''}}
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-6 pr-0">
                                <strong>{{'user.gender' | translate}}: </strong>
                            </div>
                            <div class="col-6 pl-0">
                                {{profile["gender"]}}
                            </div>
                        </div>
                                                                        <div class="row">
                            <div class="col-6 pr-0">
                                <strong>{{'user.children' | translate}}: </strong>
                            </div>
                            <div class="col-6 pl-0">
                                {{profile["children"]}}
                            </div>
                        </div>
                                                <div class="row">
                            <div class="col-6 pr-0">
                                <strong>{{'user.motor_vehicle' | translate}}: </strong>
                            </div>
                            <div class="col-6 pl-0">
                                {{profile["motor_vehicle"]}}
                            </div>
                        </div>
                                                <div class="row">
                            <div class="col-6 pr-0">
                                <strong>{{'user.odim' | translate}}: </strong>
                            </div>
                            <div class="col-6 pl-0">
                                {{profile["odim"]}}
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-6 pr-0">
                                <strong>{{'user.address' | translate}}: </strong>
                            </div>
                            <div class="col-6 pl-0">
                                {{profile["fullAddress"]}}
                            </div>
                        </div>
                        <hr>
                        <span class="dark-gray-text uppercase"><strong>{{'user.primary_contact' | translate}}</strong></span>
                        <div class="row">
                            <div class="col-6 pr-0">
                                <strong>{{'general.name' | translate}}: </strong>
                            </div>
                            <div class="col-6 pl-0">
                                {{profile["primaryContactName"]}}
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-6 pr-0">
                                <strong>{{'general.phone_number' | translate}}: </strong>
                            </div>
                            <div class="col-6 pl-0">
                                {{profile["primaryContactPhoneNumber"]}}
                            </div>
                        </div>
                        <hr>
                        <span class="dark-gray-text uppercase"><strong>{{'user.secondary_contact' | translate}}</strong></span>
                        <div class="row">
                            <div class="col-6 pr-0">
                                <strong>{{'general.name' | translate}}: </strong>
                            </div>
                            <div class="col-6 pl-0">
                                {{profile["secondaryContactName"]}}
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-6 pr-0">
                                <strong>{{'general.phone_number' | translate}}: </strong>
                            </div>
                            <div class="col-6 pl-0">
                                {{profile["secondaryContactPhoneNumber"]}}
                            </div>
                        </div>
                        <hr>
                        <div>
    <span class="dark-gray-text uppercase"><strong>{{'aggressor.list_title' | translate}}</strong></span>
    
    <!-- Loop through aggressors -->
     <div  *ngIf="aggressors && aggressors.length > 0">
    <div  *ngFor="let aggressor of aggressors; let idx = index" class="row">
        <div class="col-6 pr-0">
            <strong>{{ aggressor.aggressorName }}</strong>
        </div>
        <div class="col-6 pl-0 text-right">
            <button 
                type="button" 
                class="btn btn-sm btn-link p-0"
                (click)="openAggressorModal(aggressor)"
                [title]="'aggressor.view_details' | translate">
                <i class="fa fa-eye text-primary"></i>
            </button>
        </div>
    </div>
    <hr>
    </div>
    <!-- No aggressors message -->
<div *ngIf="!aggressors || aggressors.length === 0" class="row">
    <div class="col-2"></div>
    <div class="col-8">
        <p class="text-muted text-center">{{ 'aggressor.no_records' | translate }}</p>
    </div>
    <div class="col-2"></div>
</div>

</div>
                        <div *ngIf="fieldOption">
                            <span class="dark-gray-text uppercase"><strong>{{'setting.additional_info' | translate}}</strong></span>
                            <div *ngFor="let fields of c_fields" class="row">
                                <div class="col-6 pr-0">
                                    <strong>{{ fields.field }}: </strong>
                                </div>
                                <div class="col-6 pl-0">
                                    {{ fields.fieldValue }}
                                </div>
                            </div>
                            <hr>
                        </div>
                        <span class="dark-gray-text uppercase"><strong>{{'general.documents' | translate}}</strong></span>
                        <div class="row">
                            <div class="col-12">
                                <ul>
                                    <li *ngFor="let document of documents"><a tabindex="0" (keydown.enter)="previewPDF(document)" (click)="previewPDF(document)" class="custom-hyperlink"><strong>{{ document.name }}<span class="screen-reader-only">({{'general.opens_new_tab' | translate}})</span>
                                        <i *ngIf="document.name.slice(-3) == 'pdf'" class="fa fa-external-link ml-2" aria-hidden="true"></i>
                                    </strong></a></li>
                                </ul>
                            </div>
                        </div>
                        <hr>
                        <span class="dark-gray-text"><strong>AUDIOS/VIDEOS</strong></span>
                        <div class="row" *ngIf="selectedAlert?.compositionSid">
                            <div class="col-12">
                                <a tabindex="0" *ngFor="let composition of compositionList" (keydown.enter)="viewMedia(composition)" (click)="viewMedia(composition)" class="custom-hyperlink"><strong>{{'general.view' | translate}}<span class="screen-reader-only">({{'general.opens_new_tab' | translate}})</span><i class="fa fa-external-link ml-2" aria-hidden="true"></i></strong><br></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xs-12 col-lg-6">
                <div class="p-0 col-12">
                    <span *ngIf="selectedAlert.initialLatitude && selectedAlert.initialLongitude">
                        <strong>{{'alert.initial_latitude' | translate}}:</strong> {{selectedAlert.initialLatitude}} 
                        <strong>{{'alert.initial_longitude' | translate}}:</strong> {{selectedAlert.initialLongitude}}
                        <br>
                    </span>
                    <span *ngIf="finalLatitude && finalLongitude">
                        <strong>{{'alert.final_latitude' | translate}}: </strong><span>{{finalLatitude}}</span>&nbsp;
                        <strong>{{'alert.final_longitude' | translate}}: </strong><span>{{finalLongitude}}</span><br>
                    </span>
                </div>
                <div class="p-0 col-12">
                    <div #mapAlert id="mapAlert" class="map-style"></div>
                    <div class="row pt-1">
                        <div class="col-4">
                            <strong>{{'roles.User' | translate}}</strong>
                            <ul class="legend">
                                <li><img class="icon" src="https://maps.google.com/mapfiles/ms/icons/blue-dot.png"> {{'alert.previous_position' | translate}}</li>
                                <li><img class="icon" src="https://maps.google.com/mapfiles/ms/icons/green-dot.png"> {{'alert.final_position' | translate}}</li>
                            </ul>
                        </div>
                        <div class="col-4">
                            <strong>{{'roles.SecurityAgent' | translate}}</strong>
                            <ul class="legend">
                                <li><img class="icon" src="https://maps.google.com/mapfiles/ms/icons/yellow-dot.png"> {{'alert.previous_position' | translate}}</li>
                                <li><img class="icon" src="https://maps.google.com/mapfiles/ms/icons/orange-dot.png"> {{'alert.final_position' | translate}}</li>
                            </ul>
                        </div>
                        <div class="col-4">
                            <strong>{{'general.alert' | translate}}</strong>
                            <ul class="legend">
                                <li><img class="icon" src="https://maps.google.com/mapfiles/ms/icons/red-dot.png"> {{'alert.final_position' | translate}}</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <br>
        <div class="row pb-4">
            <div class="col-12">
                <div class="card border-top">
                    <div class="pl-3 pr-3">
                        <h5 class="mt-3 mb-0">{{'general.conversation' | translate}}</h5>
                        <hr class="mb-0">
                    </div>
                    <div class="messaging">
                        <div class="bg-white">
                            <div class="mesgs">
                                <div #msg_history class="msg_history" [scrollTop]="msg_history.scrollHeight">
                                    <ng-container *ngFor="let d of chatMessages">
                                        <div *ngIf="(d.senderId === selectedAlert.createdBy.toString())">
                                            <div class="incoming_msg">
                                                <div class="received_msg">
                                                    <div class="received_withd_msg">
                                                        <span class="time_date" *ngIf="d.contentType !== 3">{{ selectedAlert.createdByName }}</span>
                                                        <p class="text-break" *ngIf="d.contentType === 0">{{ d.message }}</p>
                                                        <a tabindex="0" *ngIf="d.contentType === 1" (keydown.enter)="functionsService.openImage(d.profilePicLink)" (click)="functionsService.openImage(d.profilePicLink)"><img [src]="d.profilePicLink" [alt]="d.profilePicLink" class="rounded img-chat" /></a>
                                                        <div *ngIf="d.contentType === 2" [id]="d.id" class="rounded h-150" [chatLocation]="d.content"></div>
                                                        <span class="time_date" *ngIf="d.contentType !== 3">{{ d.timestamp | date: 'MM/dd/yyyy | h:mm:ss a' }}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div *ngIf="(d.senderId !== selectedAlert.createdBy.toString()) && (d.senderId !== selectedAlert.attendedBy.toString())">
                                            <div class="outgoing_msg">
                                                <div class="sent_msg">
                                                    <span class="time_date" *ngIf="d.contentType !== 3 && !d.senderName">{{ 'general.representative' | translate}} #{{d.ownerID}} </span>
                                                    <span class="time_date" *ngIf="d.contentType !== 3 && d.senderName">{{d.senderName}} </span>
                                                    <p class="text-break" *ngIf="d.contentType === 0">{{ d.message }}</p>
                                                    <a tabindex="0" *ngIf="d.contentType === 1" (keydown.enter)="functionsService.openImage(d.profilePicLink)" (click)="functionsService.openImage(d.profilePicLink)"><img [src]="d.profilePicLink" [alt]="d.profilePicLink" class="rounded img-chat" /></a>
                                                    <div *ngIf="d.contentType === 2" [id]="d.id" class="rounded h-150" [chatLocation]="d.content"></div>
                                                    <span class="time_date" *ngIf="d.contentType !== 3">{{ d.timestamp | date: 'MM/dd/yyyy | h:mm:ss a'}}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div *ngIf="(d.senderId !== selectedAlert.createdBy.toString()) && (d.senderId === selectedAlert.attendedBy.toString())">
                                            <div class="outgoing_msg">
                                                <div class="sent_msg">
                                                    <span class="time_date" *ngIf="d.contentType !== 3">{{ selectedAlert.attendedByName }}</span>
                                                    <p class="text-break" *ngIf="d.contentType === 0">{{ d.message }}</p>
                                                    <a *ngIf="d.contentType === 1" (click)="functionsService.openImage(d.profilePicLink)"><img [src]="d.profilePicLink" [alt]="d.profilePicLink" class="rounded img-chat" /></a>
                                                    <div *ngIf="d.contentType === 2" [id]="d.id" class="rounded h-150" [chatLocation]="d.content"></div>
                                                    <span class="time_date" *ngIf="d.contentType !== 3">{{ d.timestamp | date: 'MM/dd/yyyy | h:mm:ss a'}}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </ng-container>
                                    <div *ngIf="chatMessages.length === 0" class="dark-gray-text">
                                        <i>{{'alert.no_messages' | translate}}</i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Aggressor Details Modal -->
<ng-template #aggressorDetailsModal let-modal>
    <div class="modal-header">
        <h5 class="modal-title dark-gray-text">
            <i class="fa fa-user"></i>
            {{ 'aggressor.information' | translate }}
        </h5>
        <button type="button" class="close" (click)="modal.dismiss()" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <!-- Aggressor Image -->
        <div class="row mb-3">
            <div class="col-12 text-center">
                <div class="aggressor-modal-image-container">
                    <img 
                        [src]="selectedAggressor?.imageUrl ? selectedAggressor?.imageUrl : 'assets/images/default-user.jpeg'" 
                        [alt]="selectedAggressor?.aggressorName"
                        class="aggressor-modal-image"
                        (error)="onImageError($event)">
                </div>
            </div>
        </div>

        <!-- Aggressor Name -->
        <div class="row">
            <div class="col-6 pr-0">
                <strong>{{ 'aggressor.name' | translate }}: </strong>
            </div>
            <div class="col-6 pl-0">
                {{ selectedAggressor?.aggressorName }}
            </div>
        </div>

        <!-- Primary Address -->
        <div *ngIf="selectedAggressor?.aggressorPrimaryAddress" class="row">
            <div class="col-6 pr-0">
                <strong>{{ 'aggressor.primary_address' | translate }}: </strong>
            </div>
            <div class="col-6 pl-0">
                {{ selectedAggressor?.aggressorPrimaryAddress }}
            </div>
        </div>

        <!-- Secondary Address -->
        <div *ngIf="selectedAggressor?.aggressorSecondaryAddress" class="row">
            <div class="col-6 pr-0">
                <strong>{{ 'aggressor.secondary_address' | translate }}: </strong>
            </div>
            <div class="col-6 pl-0">
                {{ selectedAggressor?.aggressorSecondaryAddress }}
            </div>
        </div>

        <hr>

        <!-- Protection Order Details -->
        <span class="dark-gray-text uppercase"><strong>{{ 'aggressor.protection_order' | translate }}</strong></span>
        
        <!-- Order Number -->
        <div class="row">
            <div class="col-6 pr-0">
                <strong>{{ 'aggressor.order_number' | translate }}: </strong>
            </div>
            <div class="col-6 pl-0">
                {{ selectedAggressor?.protectionOrderNumber }}
            </div>
        </div>

        <!-- Start Date -->
        <div class="row">
            <div class="col-6 pr-0">
                <strong>{{ 'aggressor.start_date' | translate }}: </strong>
            </div>
            <div class="col-6 pl-0">
                {{ selectedAggressor?.protectionOrderStartDate | date:'MM/dd/yyyy' }}
            </div>
        </div>

        <!-- End Date -->
        <div class="row">
            <div class="col-6 pr-0">
                <strong>{{ 'aggressor.end_date' | translate }}: </strong>
            </div>
            <div class="col-6 pl-0">
                {{ selectedAggressor?.protectionOrderEndDate | date:'MM/dd/yyyy' }}
            </div>
        </div>

        <!-- Precint -->
        <div class="row">
            <div class="col-6 pr-0">
                <strong>{{ 'aggressor.precinct' | translate }}: </strong>
            </div>
            <div class="col-6 pl-0">
                {{ selectedAggressor?.precint }}
            </div>
        </div>

        <!-- Agent -->
        <div class="row">
            <div class="col-6 pr-0">
                <strong>{{ 'aggressor.agent' | translate }}: </strong>
            </div>
            <div class="col-6 pl-0">
                {{ selectedAggressor?.agent }}
            </div>
        </div>

        <!-- ODIM -->
        <div class="row">
            <div class="col-6 pr-0">
                <strong>{{ 'aggressor.restricted_area' | translate }}: </strong>
            </div>
            <div class="col-6 pl-0">
                {{ selectedAggressor?.restrictedArea }}
            </div>
        </div>

        <!-- Status -->
        <div class="row">
            <div class="col-6 pr-0">
                <strong>{{ 'aggressor.status' | translate }}: </strong>
            </div>
            <div class="col-6 pl-0">
                <span [ngClass]="{
                    'badge badge-success': selectedAggressor?.status === 1,
                    'badge badge-secondary': selectedAggressor?.status === 2,
                    'badge badge-warning': selectedAggressor?.status === 3,
                    'badge badge-danger': selectedAggressor?.status === 4,
                    'badge badge-info': selectedAggressor?.status === 5
                }">
                    {{ getStatusText(selectedAggressor?.status) }}
                </span>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="modal.close()">
            <i class="fa fa-times"></i> {{ 'general.close' | translate }}
        </button>
    </div>
</ng-template>